import HttpApi from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import i18next from 'i18next'

import { dataLayerPublish } from '@dhl/datalayer'

import { forTopLevelDomain } from './config'

export const localStorageLocale = 'locale'

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- type is unknown
const localeFilesMap: Record<string, Promise<any>> = {
  'de-EU': import('./i18n/de-EU.json'),
  'en-BE': import('./i18n/en-BE.json'),
  'en-EU': import('./i18n/en-EU.json'),
  'en-NL': import('./i18n/en-NL.json'),
  'fr-BE': import('./i18n/fr-BE.json'),
  'nl-BE': import('./i18n/nl-BE.json'),
  'nl-NL': import('./i18n/nl-NL.json'),
  'cs-CZ': import('./i18n/cs-CZ.json'),
  'en-CZ': import('./i18n/en-CZ.json'),
}

// Because i18next does not keep the locales in its own state, we also export
// this function to get the locales in the Language selector
export const locales = (): string[] =>
  forTopLevelDomain<string[]>({
    eu: ['en-EU', 'de-EU'],
    be: ['nl-BE', 'en-BE', 'fr-BE'],
    nl: ['nl-NL', 'en-NL'],
    cz: ['cs-CZ', 'en-CZ'],
  })

const languageDetector = new LanguageDetector()
languageDetector.addDetector({
  name: 'detectPrimary',
  lookup() {
    return locales()[0]
  },
})

i18next
  .use(HttpApi)
  .use(languageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    backend: {
      loadPath: async (languages: string[]) => {
        const localeFile = await localeFilesMap[languages[0]]

        return localeFile.default
      },
    },
    saveMissing: true,
    showSupportNotice: false,
    missingKeyHandler: (_lngs, _ns, key) => {
      dataLayerPublish('ERROR', {
        id: 'i18n',
        message: `i18n - missing '${i18next.language}' translation for key '${key}'`,
      })
    },
    debug: false,
    supportedLngs: locales(),
    returnNull: false,
    detection: {
      order: ['localStorage', 'navigator', 'detectPrimary'],
      lookupLocalStorage: localStorageLocale,
    },
    keySeparator: '.',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export const i18n = i18next
